import React from 'react';
import PricingSection from '../components/PricingSection';
import Layout from '../components/layout';
import CTA from '../components/CTA';
import SEO from '../components/seo/seo';

export default ({ location }) => {
  return (
    <Layout>
      <SEO title="Pricing" pathname={location.pathname} />
      <div className="container pt-8">
        <PricingSection
          isPage
          title="Actionable feedback at an affordable price"
        />
      </div>
      <CTA />
    </Layout>
  );
};
